// extracted by mini-css-extract-plugin
export default {"form":"PatientStep10_form__imepT"};